import { supabase } from '../supabaseClient'

const STORAGE_PREFIX = 'kilo.calibration.calendar'

function storageKey(userId: string): string {
  return `${STORAGE_PREFIX}.${userId}`
}

export function clearCalibrationCalendarStorage(userId: string): void {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.removeItem(storageKey(userId))
}

/**
 * Wipes calibration progress so body calibration always starts fresh before
 * initial protocol generation or a protocol repair run.
 */
export async function resetCalibrationState(userId: string): Promise<{ error: string | null }> {
  clearCalibrationCalendarStorage(userId)

  const { error: metricsError } = await supabase.from('calibration_metrics').delete().eq('user_id', userId)
  if (metricsError) {
    return { error: metricsError.message }
  }

  const { error: profileError } = await supabase
    .from('profiles')
    .update({
      calibration_status: 'not_started',
      calibration_completed_sessions: 0,
      progression_engine_config: null,
      production_week_start: null,
    })
    .eq('id', userId)

  return { error: profileError?.message ?? null }
}
